// extracted by mini-css-extract-plugin
export default {"fs":"fb6d59009f _21be662277"};